/* „Twój kod trenera" — the card's own line and its one control. The card, its title and its body
 * are `AccountScreen.module.css`'s `.card`, so nothing is declared on both sides.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

/* The reserve. Sized before the read answers, so the skeleton bar, the code and the refusal all
 * stand in one box — the gate switches ink and never geometry. */
.codeLine {
  display: flex;
  align-items: center;
  height: var(--h-account-code);
  margin: var(--space-4) var(--space-0);
}

.code {
  font-size: var(--fs-account-code);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-none);
  letter-spacing: var(--ls-eyebrow);
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.codeBar {
  width: 62%;
  height: var(--fs-h2);
}

.unavailable {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

/* The mockup's `.btn.ink.lg`: 40px, radius 13, full width. The skin states no geometry, so all of
 * it is declared here — a control wearing the skin and declaring none renders square at weight 400. */
.action {
  gap: var(--space-2);
  justify-content: center;
  width: 100%;
  height: var(--h-account-card-button);
  padding: var(--space-0) var(--space-4);
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-bold);
  letter-spacing: normal;
  border-radius: var(--radius-13px);
}

.actionIcon {
  display: block;
  flex: none;
  width: var(--sz-account-glyph);
  height: var(--sz-account-glyph);
}
